import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const FileSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9 12.5H3C2.17157 12.5 1.5 11.8284 1.5 11L1.5 3C1.5 2.17157 2.17157 1.5 3 1.5L5 1.5V4C5 5.65685 6.34315 7 8 7H10.5V11C10.5 11.8284 9.82843 12.5 9 12.5ZM10.3033 5.5C10.2375 5.38462 10.1562 5.27752 10.0607 5.18198L6.81802 1.93934C6.72248 1.8438 6.61538 1.76248 6.5 1.69674V4C6.5 4.82843 7.17157 5.5 8 5.5H10.3033ZM11.1213 4.12132C11.6839 4.68393 12 5.44699 12 6.24264L12 11C12 12.6569 10.6569 14 9 14H3C1.34315 14 0 12.6569 0 11V3C0 1.34315 1.34315 0 3 0H5.75736C6.55301 0 7.31607 0.316071 7.87868 0.87868L11.1213 4.12132Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default FileSvg;
